import React from 'react';
import CodeMirrorHolder from './Components/CodeMirrorHolder';

export default function App() {
  return (
    <div style={{ display: 'flex', margin: 0 }}>
      <CodeMirrorHolder />
    </div>
  );
}
